<template>
  <b-modal
    id="modal-attendance"
    dialog-class="base-modal"
    body-class="p-0"
    hide-header
    hide-header-close
    hide-footer
    centered
    @hidden="changeAttendance"
  >
    <div id="event-attendance" :class="{ 'drop-event': dropEvent?.isEvent }">
      <div v-if="dropEvent?.isEvent" class="event-body">
        <img
          v-if="!isMobile"
          style="position: absolute; top: -67px; transform: translateX(-50%); width: 140px; left: 50%"
          :src="`${$s3}/img/common/map/map_event.png?${$ver}`"
        />
        <div class="event-title" style="font-weight: bold; color: #333333; letter-spacing: -0.4px">
          {{ $t('modal.attendance.event.title') }}
        </div>
        <div>
          {{
            $t('modal.attendance.event.content', {
              date: getPeriodTxt(dropEvent?.startDate, dropEvent?.endDate),
            })
          }}
        </div>
        <div
          class="drop-event-content d-flex align-items-center place-content-center"
          style="place-content: center"
          v-html="
            $t('modal.attendance.event.content1', {
              url: `${$s3}/img/common/event/drop_event.webp?${$ver}`,
              omc: 0.05,
            })
          "
        ></div>
      </div>

      <div class="attendance mb-0" :class="{ event: attendanceEvent?.isEvent }">
        <div class="event-title" v-if="attendanceEvent?.isEvent">
          <img class="event-title-bg" :src="`${$s3}/img/common/attendance/title_background.webp?${$ver}`" />
          <img
            class="event-title-img"
            :src="`${$s3}/img/${lang}/attendance/${attendanceEvent?.isEvent}.webp?${$ver}`"
          />
        </div>

        <template v-else>
          <div class="title">{{ $t('modal.attendance.title') }}</div>

          <div class="modal-content" style="background: #00000000">
            {{ $t('modal.attendance.content') }}

            <div>{{ $t('modal.attendance.content1', { cnt_attendance: cnt_attendance }) }}</div>
          </div>
        </template>

        <component :is="attendanceBoard" :cnt_attendance="cnt_attendance" />

        <div class="btn-wrapper">
          <div class="modal-btn confirm" :class="{ event: attendanceEvent?.isEvent }" @click.once="hideModal()">
            {{ $t('modal.confirm') }}
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex';

import Attendance from './components/Attendance.vue';

// Events
import MarEvent2024 from './components/MarEvent2024.vue';

export default {
  name: 'AttendanceAlert',
  props: ['cnt_attendance'],
  computed: {
    ...mapState(['lang', 'isMobile', 'dropEvent', 'attendanceEvent']),
    attendanceBoard() {
      if (this.attendanceEvent?.isEvent) return MarEvent2024;

      return Attendance;
    },
  },
  methods: {
    hideModal() {
      this.$bvModal.hide('modal-attendance');
    },
    changeAttendance() {
      // console.log('hidden');
      this.$store.commit('changeAttendance');
    },
    getPeriodTxt(start, end) {
      return `${this.$tfDate(this.$tl(start, this.lang))} ~ ${this.$tfMonthDay(this.$tl(end, this.lang))} (${this.$tl(
        end,
        this.lang
      ).toFormat('HH:mm')})`;
    },
  },
};
</script>

<style lang="scss">
#modal-attendance___BV_modal_body_ {
  background: none;
}
</style>

<style lang="scss" scoped>
.drop-event-content {
  ::v-deep {
    img {
      width: 18px;
    }
  }
}

.photo-event {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 4px;

  img {
    aspect-ratio: 1 / 1;
  }
}

#event-attendance {
  background: #f5f5f5;
  border-radius: 8px;
  overflow: hidden;

  &.drop-event {
    padding: 16px;
    padding-top: 27px;

    @media screen and (max-width: 1119px) {
      padding-top: 16px;
    }
  }

  .attendance {
    background: center / cover no-repeat url($s3-url + '/img/common/attendance/attendance_check_bg.svg?' + $version);
    border-radius: 8px;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);

    &.event {
      background: center / cover no-repeat url($s3-url + '/img/common/attendance/background.webp?' + $version);

      .event-title {
        position: relative;
        width: 100%;
        padding-top: 28px;

        @include mobile {
          padding-top: 24px;
        }

        img.event-title-img {
          position: relative;
          display: block;
          width: 75%;
          margin: 0 auto;
          z-index: 2;
        }
        .event-title-bg {
          position: absolute;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 95%;
          z-index: 1;
        }
      }

      .modal-btn.confirm.event {
        background: #ffffff;
        color: #333333;
      }
    }
  }

  .event-body {
    text-align: center;
    color: #666666;
    padding-bottom: 10px;

    .event-title {
      font-weight: 600;
      font-size: 20px;
      color: #333333;
    }
  }
}
</style>
